import Category from "components/admin/views/management/product/Category";

export const MODAL_FORM_ERRORS = {
  PROJECT: "Hubo un error con este proyecto.",
  COMMENT: "Hubo un error con este comentario.",
  BLOG_SLIDE: "Hubo un error con este blog slide.",
  BLOG: "Hubo un error con este blog.",
  CLIENT: "Hubo un error con este cliente.",
  FAQ: "Hubo un error con este faq.",
  FLOOR_PLANS: "Hubo un error con este detalle de projecto.",
  PRODUCT_HELP: "Hubo un error con este video de ayuda.",
  CATEGORY: "Hubo un error con esta categoría.",
  PRODUCT: "Hubo un error con este producto.",
  PRODUCT_OPTIONS: "Hubo un error con esta opción de producto.",
  SPECIFICATION: "Hubo un error con esta especificación.",
  FILTERS: "Hubo un error con este filtro.",
  PRODUCT_FILTER: "Hubo un error con esta imagen de producto.",
  PROJECT_FILTER: "Hubo un error con este filtro de proyecto.",
};
